import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import { Button, Form, Modal, Radio, Text, TextArea } from 'tea-component';

import './index.scss';
import BubbleCommon from '@/pages/opinion/components/BubbleCommon';
import {
  aigcDownloadTips,
  aigcPromptTips,
} from '@/pages/opinion/components/BubbleCommon/copywritingKey/aigc';
import { connect, getLocale, useIntl } from 'umi';
import EmailInput from '../../../EmailInput';
import moment from 'moment';
import SvgIcon from '@/pages/home/components/SvgIcon'; 
import { getPromptList, getPromptText } from '../../constants';
import useGptHistoryPrompt from '../../hooks/useGptHistoryPrompt';
import CardCommon from '../../../CardCommon';
import { buriedBtnPoint } from '@/pages/opinion/operationLog/buriedPoint';
import { DBO_T } from '@op/utils/format';

function EmailFormModal({
  setValue,
  handleAigcConfirm,
  params,
  getChangeHistorical,
  prompt,
  setPrompt,
  getPromptTextFunc,
  saveUserPrompt,
  topic,
  showAigcWithoutDialog,
  setShowAigcWithoutDialog
}: any) {
  const { formatMessage } = useIntl();
  const [errorText, setErrorText] = useState('');

  const language = getLocale();

  const [emailList, setEmailList] = useState<Array<string>>([]);
  const [showEmailMessage, setShowEmailMessage] = useState(false);
  // 先修改为 page 方便调试
  const [resultType, setResultType] = useState<'download' | 'page' | 'gpt'>(
    'page',
  );

  const handleClose = () => {
    setValue?.(false);
  };

  const handleConfirm = async () => {
    if (resultType === 'gpt') {
      handleAigcConfirm?.({
        emailList: emailList,
        resultType,
      });
    } else {
      if (prompt?.trim() === '') return;
      saveUserPrompt();
      handleAigcConfirm?.({
        prompt: prompt,
        resultType,
      });
    }
    buriedBtnPoint('GPT_Confirm');
    handleClose();
  };

  // 初始化进入页面直接加载gpt报告不需要显示弹窗
  useEffect(() => {
    if(showAigcWithoutDialog){
      handleConfirm();
      setShowAigcWithoutDialog(false);
    };
  }, [showAigcWithoutDialog]);
  

  const [active, setActive] = useState(topic ? 4 : 1);

  useEffect(() => {
    const defaultPrompt1 = getPromptTextFunc(0);
    const defaultPrompt2 = getPromptTextFunc(1);
    const defaultPrompt3 = getPromptTextFunc(2);
    const defaultPrompt4 = getPromptTextFunc(3);

    if (
      prompt !== defaultPrompt1 &&
      prompt !== defaultPrompt2 &&
      prompt !== defaultPrompt3 &&
      prompt !== defaultPrompt4
    ) {
      setActive(-1);
    }
  }, [prompt]);

  return (
    <>
      <Modal.Body>
        <Form style={{ width: '100%' }} className="teaui-form-alignment">
          <Form.Item
            label={formatMessage({ id: 'Result Output' })}
            className="dbo-aigc-radio-wrapper"
          >
            <Radio.Group
              value={resultType}
              onChange={(value: any) => {
                setResultType(value);
              }}
            >
              <Radio name="download" className="radio-item">
                {formatMessage({ id: 'Download' })}
                <BubbleCommon
                  tipsMap={aigcDownloadTips}
                  placement="top"
                ></BubbleCommon>
              </Radio>
              <Radio name="page">{formatMessage({ id: 'Show on page' })}</Radio>
              {/* <Radio name="gpt" className="radio-item">
                {formatMessage({ id: 'GPT Auto Report' })}
              </Radio> */}
            </Radio.Group>
          </Form.Item>
          {resultType !== 'gpt' ? (
            <Form.Item
              status={errorText ? 'error' : undefined}
              showStatusIcon={false}
              message={errorText}
              className="dbo-prompt-form-item"
              label={
                <div className="item-label">
                  {formatMessage({ id: 'Prompt' })}
                  <span style={{ color: '#ef5858', marginLeft: 5 }}>*</span>
                  <BubbleCommon
                    tipsMap={aigcPromptTips}
                    placement="top"
                  ></BubbleCommon>
                </div>
              }
            >
              <TextArea
                className="dbo-aigc-modal-textarea"
                value={prompt}
                onChange={(value) => {
                  setErrorText(
                    value.trim()
                      ? ''
                      : formatMessage({ id: 'Please enter prompt.' }),
                  );
                  setPrompt(value);
                }}
              />
              <div className="dbo-aigc-modal-exit">
                {/* disabled 类名 disabled */}
                <div className="dbo-aigc-modal-exit-left">
                  {formatMessage({ id: 'Default prompt' })}:
                  {(topic ? [1, 2, 3, 4] : [1, 2]).map((item, index) => {
                    return (
                      <div
                        className={
                          item === active
                            ? 'dbo-aigc-modal-exit-actiontab'
                            : 'dbo-aigc-modal-exit-tab'
                        }
                        onClick={() => {
                          setPrompt(getPromptTextFunc(index));
                          setActive(item);
                        }}
                        key={item}
                      >
                        {item}
                      </div>
                    );
                  })}
                </div>
                <div className="dbo-aigc-modal-exit-right">
                  <div
                    className={`dbo-aigc-modal-exit-item ${
                      !prompt.trim() ? 'disabled' : ''
                    }`}
                    onClick={getChangeHistorical}
                  >
                    <SvgIcon
                      type="clock"
                      className="dbo-aigc-modal-exit-icon"
                    />
                    {formatMessage({ id: 'Historical prompt' })}
                  </div>
                  <div
                    className={`dbo-aigc-modal-exit-item ${
                      !prompt.trim() ? 'disabled' : ''
                    }`}
                    onClick={() => {
                      if (prompt.trim())
                        DBO_T.copyText(prompt, formatMessage);
                    }}
                  >
                    <SvgIcon
                      type="datalab-copy"
                      className="dbo-aigc-modal-exit-icon"
                    />
                    {formatMessage({ id: 'Copy' })}
                  </div>
                </div>
              </div>
            </Form.Item>
          ) : (
            <Form.Item
              className="dbo-email-item"
              required
              label={formatMessage({ id: 'Email' })}
              showStatusIcon={false}
              status={showEmailMessage ? 'error' : undefined}
              message={
                <div>
                  {showEmailMessage && (
                    <p>
                      {formatMessage({
                        id: 'Please enter the correct email address',
                      })}
                    </p>
                  )}

                  {language === 'en-US' ? (
                    <p className="text-tips-info">
                      An English GPT report will be generated for you from{' '}
                      <Button type="link" style={{ color: '#262832' }}>
                        {params?.start_time &&
                          moment(params.start_time).format('YYYY-MM-DD')}
                      </Button>{' '}
                      to{' '}
                      <Button type="link" style={{ color: '#262832' }}>
                        {params?.end_time &&
                          moment(params.end_time).format('YYYY-MM-DD')}
                      </Button>{' '}
                      . Could you please confirm the email address to receive
                      the report? You can click to{' '}
                      <a
                        target="_blank"
                        href="https://databrain-global.intlgame.com/v2/opinion/gpt/GPT%20Auto%20Report?gameid=e1fe4bf56877e8604380470315d9553a9&start_time=2024-02-25&end_time=2024-02-25&language=en&kind=1&dateTab=Day"
                      >
                        view
                      </a>{' '}
                      the preview format.
                    </p>
                  ) : (
                    <p className="text-tips-info">
                      我们将为您生成一份从{' '}
                      <Button type="link" style={{ color: '#262832' }}>
                        {params?.start_time &&
                          moment(params.start_time).format('YYYY-MM-DD')}
                      </Button>{' '}
                      到{' '}
                      <Button type="link" style={{ color: '#262832' }}>
                        {params?.end_time &&
                          moment(params.end_time).format('YYYY-MM-DD')}
                      </Button>{' '}
                      的英文 GPT 报告。请确认接收报告的电子邮件地址。您可以点击
                      <a
                        target="_blank"
                        href="https://databrain-global.intlgame.com/v2/opinion/gpt/GPT%20Auto%20Report?gameid=e1fe4bf56877e8604380470315d9553a9&start_time=2024-02-25&end_time=2024-02-25&language=en&kind=1&dateTab=Day"
                      >
                        预览
                      </a>
                      报告格式。
                    </p>
                  )}
                </div>
              }
            >
              <EmailInput
                value={emailList}
                placeholder={formatMessage({
                  id: 'Please enter a Email',
                })}
                onChange={(tags, isError) => {
                  setEmailList(tags);
                  setShowEmailMessage(isError);
                }}
              />
            </Form.Item>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="primary"
          onClick={handleConfirm}
          disabled={
            !!errorText || (resultType === 'gpt' && emailList.length === 0)
          }
        >
          {formatMessage({ id: 'Confirm' })}
        </Button>
        <Button type="weak" onClick={handleClose}>
          {formatMessage({ id: 'Cancel' })}
        </Button>
      </Modal.Footer>
    </>
  );
}

function EmailModal(props: any) {
  const { formatMessage } = useIntl();
  const { value, setValue, wholeGameInfo, topic } = props;

  const language = getLocale();

  // 保证拿到的时候通用文案
  const originDefaultPromptList = getPromptList(
    wholeGameInfo.entity_name,
    topic,
  );
  const getPromptTextFunc = getPromptText(
    language,
    originDefaultPromptList,
    wholeGameInfo.entity_name,
  );

  const [prompt, setPrompt] = useState(getPromptTextFunc(topic ? 3 : 0));

  const close = () => {
    setValue?.(false);
  };

  const {
    loading,
    userPromptList,
    setUserHistoryPrompt,
    getUserHistoryPrompt,
  } = useGptHistoryPrompt({
    gameInfo: wholeGameInfo,
  });

  const saveUserPrompt = () => {
    const defaultPrompt1 = getPromptTextFunc(0);
    const defaultPrompt2 = getPromptTextFunc(1);
    const defaultPrompt3 = getPromptTextFunc(2);
    const defaultPrompt4 = getPromptTextFunc(3);

    const flag = userPromptList.some((item) => item.prompt_detail === prompt);

    if (
      prompt !== defaultPrompt1 &&
      prompt !== defaultPrompt2 &&
      prompt !== defaultPrompt3 &&
      prompt !== defaultPrompt4 &&
      !flag
    ) {
      setUserHistoryPrompt(prompt);
    }
  };

  const [visible, setVisible] = useState(false);
  const getChangeHistorical = () => {
    setValue?.(false);
    setVisible(true);
    getUserHistoryPrompt();
  };

  const closeHistoricalPrompt = () => {
    setValue?.(true);
    setVisible(false);
  };

  useEffect(() => {
    setPrompt(getPromptTextFunc(topic ? 3 : 0));
  }, [formatMessage]);

  return (
    <>
      <Modal
        visible={value}
        caption={formatMessage({ id: 'GPT Settings' })}
        onClose={close}
        size={800}
        className="dbo-aigc-modal-wrapper"
      >
        <EmailFormModal
          {...props}
          prompt={prompt}
          setPrompt={setPrompt}
          getPromptTextFunc={getPromptTextFunc}
          getChangeHistorical={getChangeHistorical}
          saveUserPrompt={saveUserPrompt}
        ></EmailFormModal>
      </Modal>
      <Modal
        visible={visible}
        className="dbo-historical-modal"
        size={800}
        caption={
          <div className="dbo-historical-modal-title">
            <div
              className="dbo-historical-modal-goback"
              onClick={closeHistoricalPrompt}
            >
              <SvgIcon
                type="left-pointing"
                className="dbo-historical-modal-icon"
              />
              {formatMessage({ id: 'Historical prompt' })}
            </div>
            <div className="dbo-historical-modal-cilck">
              {formatMessage({ id: 'Click to apply' })}
            </div>
          </div>
        }
      >
        <Modal.Body>
          <CardCommon
            contentCard
            empty={userPromptList.length === 0}
            loading={loading}
            emptyHeight={460}
            loadingHeight={460}
          >
            {userPromptList.map((item) => {
              return (
                <Text
                  tooltip={formatMessage({ id: 'Click to apply' })}
                  key={item.update_time}
                  onClick={() => {
                    setPrompt(item.prompt_detail);
                    closeHistoricalPrompt();
                  }}
                >
                  <div className="dbo-historical-modal-item">
                    <div className="dbo-historical-modal-date">
                      {item.update_time}
                    </div>
                    <div className="dbo-historical-modal-text">
                      {item.prompt_detail}
                    </div>
                  </div>
                </Text>
              );
            })}
          </CardCommon>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default connect((state: any) => {
  const { opinionCommon } = state;

  return {
    wholeGameInfo: opinionCommon.wholeGameInfo,
  };
})(EmailModal);
